import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendar,
  faUser,
  faCreditCard,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";
import { transactionService } from "../../../services";

const TransactionDetails = () => {
  const { id } = useParams();
  console.log(id);
  const [txn, setTxn] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTransaction = async () => {
      try {
        const res = await transactionService.singleTransaction(id);
        setTxn(res);
      } catch (err) {
        console.error("Failed to fetch transaction:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchTransaction();
  }, [id]);

  if (loading)
    return <p className="text-center text-gray-500">Loading transaction...</p>;
  if (!txn)
    return <p className="text-center text-gray-500">Transaction not found.</p>;

  return (
    <div className="bg-white p-6 rounded-xl shadow-md max-w-2xl mx-auto">
      <h2 className="text-2xl text-center font-bold text-yellow-600 mb-6">
        Transaction Details
      </h2>

      <div className="grid grid-cols-1 gap-6 text-gray-800">
        {/* Subscriber Info */}
        <div className="bg-gray-50 p-4 rounded-lg shadow-sm">
          <h4 className="text-lg font-semibold text-gray-700 mb-2 flex items-center">
            <FontAwesomeIcon icon={faUser} className="text-gray-400 mr-2" />
            Subscriber
          </h4>
          <p className="text-sm capitalize">
            <span className="font-medium ">Username:</span> {txn.subscriber?.username}
          </p>
          <p className="text-sm">
            <span className="font-medium">Email:</span> {txn.subscriber?.email}
          </p>
        </div>

        {/* Plan Info */}
        <div className="bg-gray-50 p-4 rounded-lg shadow-sm">
          <h4 className="text-lg font-semibold text-gray-700 mb-2 flex items-center">
            <FontAwesomeIcon icon={faCreditCard} className="text-gray-400 mr-2" />
            Plan Info
          </h4>
          <p className="text-sm">
            <span className="font-medium">Plan:</span> {txn.plan?.name}
          </p>
          <p className="text-sm">
            <span className="font-medium">Price:</span>{" "}
            <span className="text-green-600 font-semibold">
              ₦{txn.plan?.price?.toFixed(2)}
            </span>
          </p>
          <p className="text-sm">
            <span className="font-medium">Quantity:</span> {txn.quantity}
          </p>
        </div>

        {/* Transaction Info */}
        <div className="bg-gray-50 p-4 rounded-lg shadow-sm">
          <h4 className="text-lg font-semibold text-gray-700 mb-2 flex items-center">
            <FontAwesomeIcon icon={faInfoCircle} className="text-gray-400 mr-2" />
            Transaction Info
          </h4>
          <p className="text-sm">
            <span className="font-medium">Description:</span> {txn.description}
          </p>
          <p className="text-sm">
            <span className="font-medium">Reference:</span> {txn.reference}
          </p>
          <p className="text-sm">
            <span className="font-medium">Amount:</span>{" "}
            <span className="text-green-600 font-semibold">
              ₦{txn.amount.toFixed(2)}
            </span>
          </p>
          <p className="text-sm">
            <span className="font-medium">Transaction Status:</span>{" "}
            <span
              className={`inline-block px-2 py-1 rounded text-sm ${
                txn.tnxStatus === "pending"
                  ? "bg-yellow-100 text-yellow-700"
                  : "bg-green-100 text-green-700"
              }`}
            >
              {txn.tnxStatus}
            </span>
          </p>
          <p className="text-sm">
            <span className="font-medium">Status:</span>{" "}
            <span
              className={`inline-block px-2 py-1 rounded text-sm ${
                txn.status === "new"
                  ? "bg-gray-200 text-gray-800"
                  : "bg-green-200 text-green-800"
              }`}
            >
              {txn.status}
            </span>
          </p>
          <p className="text-sm text-gray-500 mt-2 flex items-center">
            <FontAwesomeIcon icon={faCalendar} className="mr-2" />
            {txn.createdAt?.split("T")[0]}
          </p>
        </div>
      </div>
    </div>
  );
};

export default TransactionDetails;